type AssignedBlockEvent = {
  event_type: string
}

export type DriverAssignedBlock = {
  events: Array<AssignedBlockEvent | null>
}

export type DriverAssignedBlocksResponse = Array<DriverAssignedBlock | null>

function getEventName(event: AssignedBlockEvent | null): string | undefined {
  return event?.event_type
}

export function isOngoingAssignedBlock(block: DriverAssignedBlock | null): boolean {
  const events = block?.events ?? []
  const eventNames = events.map(getEventName)

  return eventNames.includes('block_started') && !eventNames.includes('commitment_ended')
}

export function hasOngoingAssignedBlock(blocks: DriverAssignedBlocksResponse): boolean {
  return blocks.some(isOngoingAssignedBlock)
}
